/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { SearchFacet } from './SearchFacet';
import {
    SearchFacetFromJSON,
    SearchFacetFromJSONTyped,
    SearchFacetToJSON,
    SearchFacetToJSONTyped,
} from './SearchFacet';
import type { SolrProjectReduced } from './SolrProjectReduced';
import {
    SolrProjectReducedFromJSON,
    SolrProjectReducedFromJSONTyped,
    SolrProjectReducedToJSON,
    SolrProjectReducedToJSONTyped,
} from './SolrProjectReduced';

/**
 * 
 * @export
 * @interface SolrResultSolrProjectReduced
 */
export interface SolrResultSolrProjectReduced  {
    /**
     * 
     * @type {number}
     * @memberof SolrResultSolrProjectReduced
     */
    numberResults?: number;
    /**
     * 
     * @type {Array<SolrProjectReduced>}
     * @memberof SolrResultSolrProjectReduced
     */
    results?: Array<SolrProjectReduced>;
    /**
     * 
     * @type {Array<SearchFacet>}
     * @memberof SolrResultSolrProjectReduced
     */
    facets?: Array<SearchFacet>;
}

/**
 * Check if a given object implements the SolrResultSolrProjectReduced interface.
 */
export function instanceOfSolrResultSolrProjectReduced(value: object): value is SolrResultSolrProjectReduced {
    return true;
}

export function SolrResultSolrProjectReducedFromJSON(json: any): SolrResultSolrProjectReduced {
    return SolrResultSolrProjectReducedFromJSONTyped(json, false);
}

export function SolrResultSolrProjectReducedFromJSONTyped(json: any, ignoreDiscriminator: boolean): SolrResultSolrProjectReduced {
    if (json == null) {
        return json;
    }
    return {
        
                  'numberResults': json['numberResults'] == null ? undefined : json['numberResults'],
              'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(SolrProjectReducedFromJSON)),
              'facets': json['facets'] == null ? undefined : ((json['facets'] as Array<any>).map(SearchFacetFromJSON)),
    };
}

export function SolrResultSolrProjectReducedToJSON(json: any): SolrResultSolrProjectReduced {
    return SolrResultSolrProjectReducedToJSONTyped(json, false);
}

export function SolrResultSolrProjectReducedToJSONTyped(value?: SolrResultSolrProjectReduced | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'numberResults': value['numberResults'],
        'results': value['results'] == null? value['results']: (value['results'] as Array<any>).map(SolrProjectReducedToJSON),
        'facets': value['facets'] == null? value['facets']: (value['facets'] as Array<any>).map(SearchFacetToJSON),
    };
}


